import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

export const StyledVoiceChatToolbarStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  flexDirection: 'row',
  gap: theme.spacing(8),
}));

const SEARCH_WIDGET_HEIGHT = 114;
const HEADER_HEIGHT = 92;
const OFFSET = 15;

export const StyledWrapperStack = styled(Stack)(() => ({
  minHeight: `calc(100vh - ${SEARCH_WIDGET_HEIGHT + HEADER_HEIGHT + OFFSET}px)`,
}));
